// extracted by mini-css-extract-plugin
export default {"reschedule":"index-module--reschedule--b690e","tabs":"index-module--tabs--63f3f"};